// Document operations hook - Fixed
import { useAppDispatch, useAppSelector } from './useAppDispatch';
import {
  fetchDocuments,
  fetchDocumentById,
  uploadDocument,
  deleteDocument,
  setCurrentDocument,
  clearCurrentDocument,
} from '../store/slices/documentSlice';

export const useDocuments = () => {
  const dispatch = useAppDispatch();
  const {
    documents = [], // Add default empty array
    currentDocument,
    loading,
    error,
    uploadProgress,
    processingStatus,
  } = useAppSelector((state) => state.documents);

  const loadDocuments = () => {
    dispatch(fetchDocuments());
  };

  const loadDocument = (id: string) => {
    dispatch(fetchDocumentById(id));
  };

  const uploadNewDocument = (file: File, onProgress?: (progress: number) => void) => {
    return dispatch(uploadDocument({ file, onProgress }));
  };

  const removeDocument = (id: string) => {
    return dispatch(deleteDocument(id));
  };

  const selectDocument = (document: any) => {
    dispatch(setCurrentDocument(document));
  };

  const clearSelected = () => {
    dispatch(clearCurrentDocument());
  };

  return {
    documents: Array.isArray(documents) ? documents : [], // Ensure it's always an array
    currentDocument,
    loading,
    error,
    uploadProgress,
    processingStatus,
    loadDocuments,
    loadDocument,
    uploadNewDocument,
    removeDocument,
    selectDocument,
    clearSelected,
  };
};